import React from 'react';
import Router, { Route, Switch } from 'react-router';

import VintageGuitarsDetail from './VintageGuitarsDetail';
import VintageGuitarsListing from './VintageGuitarsListing';

interface Props {
    match: Router.match<{}>;
}

const VintageGuitarsPage: React.StatelessComponent<Props> = (props: Props) => {
    const { match } = props;
    return (
        <Switch>
            <Route path={match.url} exact component={VintageGuitarsListing} />
            <Route path={`${match.url}/:item_alias_end`} component={VintageGuitarsDetail} />
        </Switch>
    );
};

export default VintageGuitarsPage;



// WEBPACK FOOTER //
// ./src/components/pages/vintageGuitars/VintageGuitarsPage.tsx